import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Button, Row, Col, FormGroup, Label, Input} from 'reactstrap';
import Select from 'react-select';
import {TabelaCadastro} from "../components/TabelaCadastro";
import NumberFormat from "react-number-format";
import GDVStore from "../stores/GDVStore";
import {arrayToString, createSelectOptions, percentualFormat} from "../../../utils/formatar";
import {getTipoGDVById, tipoGDVEnum} from "../../../utils/enums";
import {Validacao} from "../../comum/components/Validacao";

@inject("store")
@DataWrapper
@observer
export class CadastroGDV extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new GDVStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("GDV");

        this.tipoGDVOptions = createSelectOptions(tipoGDVEnum, "id", "valor");

        this.controller.carregarLista();
    }

    /* modais (body e botões) */
    modalForm = (editMode) => {
        const empresaGloboOptions = createSelectOptions(this.controller.empresasGlobo.filter(item => item.ativo), "id", ["nome"]);
        const cargoOptions = createSelectOptions(this.controller.cargos, "id", "nome");
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup check >
                        <Label check>
                            <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()}/>{' '}
                            <Label>Ativo</Label>
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        {!editMode &&
                            <div>
                                <Label>Unidade de negócio (BU) <sup>*</sup></Label>
                                <Select simpleValue options={empresaGloboOptions} value={this.controller.itemSelecionado.empresaGloboId}
                                        onChange={(value) => this.controller.setEmpresaGloboId(value)} multi={false} placeholder="Selecione..."
                                        noResultsText="Nenhum resultado encontrado" />
                                <Validacao id="empresaGloboId" valor={this.controller.itemSelecionado.empresaGloboId} tipo={["isRequired"]} />
                            </div>
                        }
                        {editMode &&
                        <div>
                            <Label>Unidade de negócio (BU)</Label>
                            <Input type="text" value={this.controller.itemSelecionado.empresaGlobo.nome} readOnly/>
                        </div>
                        }
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Cargos <sup>*</sup></Label>
                        <Select simpleValue value={this.controller.itemSelecionado.cargoIds}
                                disabled={!this.controller.itemSelecionado.empresaGloboId || this.controller.desabilitarSelecionarCargos}
                                options={cargoOptions} onChange={(value) => this.controller.setCargoIds(value)}
                                multi={true} placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                        <Validacao id="cargoIds" valor={this.controller.itemSelecionado.cargoIds} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Tipo <sup>*</sup></Label>
                        <Select simpleValue options={this.tipoGDVOptions} value={this.controller.itemSelecionado.tipo}
                                onChange={(value) => this.controller.setTipo(value)} multi={false}
                                placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                        <Validacao id="tipo" valor={this.controller.itemSelecionado.tipo} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Percentual GDV <sup>*</sup></Label>
                        <NumberFormat suffix="%" maxLength={10} allowNegative={false} className="form-control" decimalPrecision={1} decimalSeparator={','} value={this.controller.itemSelecionado.percentualGdv} onChange={(event, values) => this.controller.setPercentualGdv(values.floatValue)}/>
                        <Validacao id="percentualGdv" valor={this.controller.itemSelecionado.percentualGdv} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
            </Row>
        )
    };

    obterTituloMobile = (objeto) => {
        return  objeto.empresaGlobo.nome;
    };

    obterConteudoMobile = (objeto) => {
        const ativo = objeto.ativo ? "Sim" : "Não";
        const percentual = objeto.percentualGdv ? objeto.percentualGdv + "%" : "";
        return (
            <div>
                { "Percentual GDV: " + percentual}<br/>
                { "Cargos: " + arrayToString(objeto.cargos, "nome")}<br/>
                { "Ativo: " + ativo}<br/>
            </div>
        )
    };

    obterExtraMobile = (objeto) => {
        return (
            <div>
                { "Tipo: " + getTipoGDVById(objeto.tipo).valor}<br/>
            </div>
        )
    };

    empresaGloboFormat(cell) {
        if(cell) {
            return cell && cell.nome ? cell.nome : "";
        }
    }

    tipoFormat(cell) {
        return getTipoGDVById(cell).valor;
    }

    nomesFormat(cell) {
        return arrayToString(cell, "nome")
    }

    percentualFormat(cell){
        return percentualFormat(cell)
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "empresaGlobo",
                dataFormat: this.empresaGloboFormat,
                label: "Unidade de negócio (BU)"
            },{
                field: "cargos",
                label: "Cargos",
                dataFormat: this.nomesFormat
            },{
                field: "tipo",
                label: "Tipo",
                dataFormat: this.tipoFormat
            },{
                field: "percentualGdv",
                label: "Percentual GDV",
                dataFormat: this.percentualFormat,
            },{
                field: "ativo",
                label: "Ativo",
                type: "boolean"
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'GDV'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.gdvList}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm(true)}
                            modalCadastrar={this.modalForm(false)}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            extraMobile={(row) => this.obterExtraMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

